import React from 'react'
import Create from '../../crud/create'
import fields from './fields'

const CreateUniversity = props => {
  return (
    <Create
// @ts-ignore
      title='Create University'
      fields={fields}
      apiPath='admin/universities'
      successRedirectPath={() => '/settings/universities'}
    />
  )
}

export default CreateUniversity
